// this for one filter
// import { create } from 'zustand';

// interface ButtonState {
//   activeIds: string[];
//   toggleActive: (id: string) => void;
//   setActiveIds: (ids: string[]) => void;
// }

// export const ButtonStore = create<ButtonState>((set) => ({
//   activeIds: [],
//   toggleActive: (id) =>
//     set((state) => ({
//       activeIds: state.activeIds.includes(id)
//         ? state.activeIds.filter((item) => item !== id)
//         : [...state.activeIds, id],
//     })),
//   setActiveIds: (ids: string[]) => set({ activeIds: ids }),
// }));

// this for all filter
import { create } from 'zustand';

interface ButtonState {
  activeIdsMap: Record<string, string[]>;

  setActiveIds: (key: string, ids: string[]) => void;
  toggle: (key: string, id: string) => void;
}

export const ButtonStore = create<ButtonState>((set) => ({
  activeIdsMap: {},

  setActiveIds: (key, ids) =>
    set((state) => ({
      activeIdsMap: {
        ...state.activeIdsMap,
        [key]: ids,
      },
    })),

  toggle: (key, id) =>
    set((state) => {
      const current = state.activeIdsMap[key] || [];

      return {
        activeIdsMap: {
          ...state.activeIdsMap,
          [key]: current.includes(id) ? current.filter((i) => i !== id) : [...current, id],
        },
      };
    }),
}));
